import ElementDocument from "./ElementDocument";
import ElementAsset from "./ElementAsset";
import { CheckList } from "./CheckList";

export default interface InspectionElement {
    Id: string;
    Name: string;
    SurveyElementId: number;
    ElementType: number;
    SortOrder: number;
    PreliminaryReportDescription: string;
    MinItems: number;
    MaxItems: number;
    Images: ElementAsset[];
    Documents: ElementDocument[];
    Completed: boolean;
    Guideline: boolean;
    checkList: CheckList;
    PdfChecklistValidation: PdfChecklistValidationType;
    ElementImportance: number;
    ValidForReuse: boolean;
    ReUseDocuments: boolean;
    expiryDate?: number;
    expiryDateError: boolean;
    savingExpiryDate: boolean;
}

export enum PdfChecklistValidationType {
    None = 0,
    AppChecklist = 1
}
